import '../styles/pages/About.css';
import useReveal from '../components/useReveal';

const LEADERS = [
  {
    init:   'N',
    name:   'Nipun Jain',
    role:   'Managing Director',
    color:  'red',
    bio:    "Leading Pharmchem's strategic vision, Nipun oversees global operations and fosters long-term relationships with pharmaceutical partners across 33+ countries.",
    email:  'nipun@phrmchem.net',
  },
  {
    init:   'E',
    name:   'Export Division',
    role:   'International Sales Team',
    color:  'dark',
    bio:    'Our export team manages relationships in 33+ countries, handling regulatory documentation, DMF filings, and ensuring timely delivery to global customers.',
    email:  'export@phrmchem.net',
  },
  {
    init:   'D',
    name:   'Domestic Sales',
    role:   'India Sales Team',
    color:  'gold',
    bio:    'Our domestic team serves Indian pharma formulators with prompt delivery, technical support, and competitive pricing across the Indian market.',
    email:  'sales@phrmchem.net',
  },
];

const VALUES = [
  {
    n:     '01',
    title: 'Quality Above All',
    desc:  'Quality is the hallmark of every product we manufacture. We adhere to the highest pharmacopoeial standards — IP, BP, USP, EP, IH — ensuring our APIs meet and exceed global expectations.',
  },
  {
    n:     '02',
    title: 'Long-Term Relationships',
    desc:  "We don't measure success in transactions — we measure it in partnerships. Pharmchem aspires to be an innovative, high-quality, service-oriented partner to companies worldwide.",
  },
  {
    n:     '03',
    title: 'Cost Effectiveness',
    desc:  'We believe quality APIs should be accessible. Our pricing strategy ensures that formulators around the world can compete in their markets without compromising on ingredient quality.',
  },
  {
    n:     '04',
    title: 'Reliability & Integrity',
    desc:  'Our formulators depend on us. We back every commitment with timely supply, transparent documentation, and consistent product quality — building the trust that defines a long-term partner.',
  },
];

const INFRA_LIST = [
  { icon: '🏭', title: 'Bahadurgarh Factory',       sub: 'Units 710-711, MIE, Bahadurgarh, Haryana — 124507. Our primary API manufacturing facility.' },
  { icon: '🏢', title: 'Corporate Office',           sub: 'Unit 209, Tower-D, Pioneer Urban Square, Sector 62, Gurugram — strategic hub for global operations.' },
  { icon: '⚙️', title: 'Quality Control Lab',        sub: 'Fully equipped QC laboratory with advanced analytical instruments ensuring product specifications are met at every batch.' },
  { icon: '📦', title: 'Warehousing & Logistics',    sub: 'Climate-controlled storage and efficient logistics network enabling timely dispatch to domestic and international clients.' },
];

const INFRA_CERTS = [
  { icon: '🏆', title: 'WHO GMP',     sub: 'Good Manufacturing Practice' },
  { icon: '📋', title: 'DMF Ready',   sub: 'Drug Master Files Available' },
  { icon: '⚗️', title: 'IP / BP',     sub: 'Indian & British Pharmacopoeia' },
  { icon: '🌍', title: 'USP / EP',    sub: 'US & European Standards' },
  { icon: '✅', title: 'MNC Approved', sub: 'Multiple Global MNC Approvals' },
  { icon: '🔬', title: 'QC Tested',   sub: 'Batch-Level Quality Control' },
];

function About({ navigate }) {
  useReveal();

  return (
    <>
      {/* Page hero */}
      <div className="page-hero">
        <div className="page-hero-bg"></div>
        <div className="page-hero-inner">
          <div className="eyebrow">About Pharmchem</div>
          <h1 className="headline">
            Building Business Through <em>Long Term Relations</em>
          </h1>
          <p style={{textAlign: 'justify'}}>
            A WHO GMP certified Indian API manufacturer that has been serving the global
            pharmaceutical industry since 1976 with integrity, quality, and competitive pricing.
          </p>
        </div>
      </div>

      {/* ─── INTRO ─── */}
      <div className="about-intro">
        <div className="about-intro-grid">
          <div className="reveal">
            <div className="eyebrow">Company Profile</div>
            <h2 className="headline">
              A <em>Trusted Name</em> in Global API Manufacturing
            </h2>
            <p className="lead" style={ {textAlign: 'justify',}}>
              Pharmchem is a WHO GMP Certified Indian manufacturing company, established in 1976,
              providing a broad range of cost-effective active pharmaceutical ingredients (API).
            </p>
            <p style={{ marginTop: 16, fontSize: '0.95rem', color: 'var(--ink-70)', lineHeight: 1.75 ,textAlign: 'justify'}}>
              Quality is the hallmark of all our products. At Pharmchem, we bring quality API's at
              competitive prices, allowing formulators to build a cost-effective range of formulations.
              Not surprisingly, we have become a reliable source of supply to leading formulators worldwide.
            </p>
            <div style={{ marginTop: 36, display: 'flex', gap: 16, flexWrap: 'wrap' }}>
              <button className="btn btn-red"     onClick={() => navigate('contact')}>Partner With Us</button>
              <button className="btn btn-outline" onClick={() => navigate('products')}>Our Products</button>
            </div>
          </div>

          <div className="about-vis reveal">
            <div className="about-vis-card">
              <div className="avc-num">Top 5</div>
              <div className="avc-label">Erythromycin Manufacturer Globally</div>
            </div>
            <div className="about-vis-card">
              <div className="avc-num">#2</div>
              <div className="avc-label">Silver Sulphadiazine Manufacturer</div>
            </div>
            <div className="about-vis-card">
              <div className="avc-num">#1</div>
              <div className="avc-label">Diethyl Carbamazine Citrate</div>
            </div>
          </div>
        </div>
      </div>

      {/* ─── LEADERSHIP ─── */}
      <div className="leadership">
        <div className="leadership-inner">
          <div className="reveal" style={{ textAlign: 'center', maxWidth: 520, margin: '0 auto' }}>
            <div className="eyebrow">Our Team</div>
            <h2 className="headline">Leadership & <em>Management</em></h2>
          </div>
          <div className="leadership-grid">
            {LEADERS.map((l, i) => (
              <div className={`leader-card reveal stagger-${i + 1}`} key={l.name}>
                <div className={`leader-banner ${l.color}`}>
                  <div className={`leader-avatar ${l.color}`}>{l.init}</div>
                </div>
                <div className="leader-info">
                  <div className="leader-name">{l.name}</div>
                  <div className="leader-role">{l.role}</div>
                  <p className="leader-bio">
                    {l.bio} Contact: <a href={`mailto:${l.email}`}>{l.email}</a>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ─── VALUES ─── */}
      <div className="values">
        <div className="values-inner">
          <div className="reveal" style={{ textAlign: 'center', maxWidth: 520, margin: '0 auto' }}>
            <div className="eyebrow">What We Stand For</div>
            <h2 className="headline">Our <em>Core Values</em></h2>
          </div>
          <div className="values-grid">
            {VALUES.map((v, i) => (
              <div className={`value-item reveal stagger-${i + 1}`} key={v.n}>
                <div className="value-num">{v.n}</div>
                <h3>{v.title}</h3>
                <p style={{textAlign: "justify"}}>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ─── INFRASTRUCTURE ─── */}
      <div className="infra">
        <div className="infra-inner">
          <div className="reveal">
            <div className="eyebrow">Infrastructure</div>
            <h2 className="headline">State-of-the-Art <em>Manufacturing Facilities</em></h2>
            <p className="lead" style={{ marginBottom: 0 }}>
              Our production facilities are designed for precision, scalability, and compliance
              with global standards.
            </p>
            <ul className="infra-list">
              {INFRA_LIST.map((item) => (
                <li key={item.title}>
                  <div className="infra-icon">{item.icon}</div>
                  <div className="infra-text">
                    <h4>{item.title}</h4>
                    <p>{item.sub}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="infra-certs reveal">
            {INFRA_CERTS.map((c) => (
              <div className="infra-cert-card" key={c.title}>
                <span className="icc-icon">{c.icon}</span>
                <div className="icc-title">{c.title}</div>
                <div className="icc-sub">{c.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ─── CTA BAND ─── */}
      <div className="cta-band">
        <h2>48 Years of Excellence — And Growing</h2>
        <p>Partner with one of India's most trusted API manufacturers.</p>
        <div className="cta-band-actions">
          <button className="btn btn-white"         onClick={() => navigate('contact')}>Get In Touch</button>
          <button className="btn btn-outline-white" onClick={() => navigate('presence')}>Our Global Reach</button>
        </div>
      </div>
    </>
  );
}

export default About;
